import {
  Schedule,
  Index,
  ScheduleAll
} from '../../../API/api'
import Calender from '../../../components/Calender'
import Toast from '../../../components/popup/Toast'
import Loading from '../../../components/popup/Loading'
// import imgTitle from "../../../components/newSchedule/imgTitle.vue";
import {
  isTemplateMiddle,
  isTypeNode
} from 'typescript';
import {
  dateToYMD
} from '../../../util/util';
// import 'view-design/dist/styles/iview.css';
export default {
  components: {
    Loading,
    Toast,
    Calender,
    // imgTitle
  },

  data() {
    return {
      planSchdule: require('../../../assets/images/schedule/planTitle.png'), //头部图片
      chooseWeek: new Date(),
      chooseMonth: new Date(),
      chooseDay: new Date(),
      showMonth: true,
      showWeek: false,
      showDay: false,
      allThing: [{
          title: '会议议程',
          color: "red"
        },
        {
          title: '待办事项',
          color: "blue"
        },
        {
          title: '外出',
          color: "green"
        },
        {
          title: '请假',
          color: "yellow"
        },
      ],
      isToast: false,
      toastMsg: null,
      toastState: null,
      events: [],
      crumb: [{
          label: '日程计划'
        },
        {
          label: '我的日程'
        },
        {
          label: '日程管理'
        }
      ],
      isLoading: false,
      allUser: [],
      allRoom: [],
      idOpts: [],
      dataConf: {
        search_type: '2',
        date: '',
        id: JSON.parse(localStorage.userInfo).id,
        date_type: 'month'
      },
      roomId: null,
      userId: JSON.parse(localStorage.userInfo).id,
      userInfo: JSON.parse(localStorage.userInfo),
      showUserName: JSON.parse(localStorage.getItem("userInfo")).userName,
      type: '',
      attendanceParams: {
        start_date: null,
        end_date: null,
        userId: '',
        page: 1,
        pageSize: 999,
      },
      teamId: "",
      eventMonth: [],
      eventWeek: [],
      weekTitle: "",
      showAllBtn: true,
      scheduleList: null,
      workTimeList: null,
      number: null,
      someDay: null,
      isFirst: true,
    }
  },
  methods: {
    getnumber(data) {
      this.number = data;
      let start = dateToYMD(new Date()) + ' 09:00'
      let end = dateToYMD(new Date()) + ' 10:00'
      if (data != 0) {
//日历刚加载的时候
        this.events.push({
          title: `待办事项（${this.number==null?0:this.number}）`,
          start: start,
          end: end,
          dataType: '待办事项',
          backgroundColor: 'rgba(45, 142, 248, 0.5)',
          color: 'rgba(45, 142, 248, 0.5)',
          textColor: 'black',
          todoList: [],
          id: 0,
          firstName: `待办事项（${this.number==null?0:this.number}）`
        })

      }
      if (this.type == 'agendaDay') {
        for (let i of this.events) {
          if (i.dataType != '考勤') {
            i.className = "textitle"
          }

        }
      }

    },
    init() {
      this.initDate();
      this.getAllUser();
      // sessionStorage.setItem('subMenu', 'schedule/manage')
      // this.$store.dispatch('setCurrSubMenu', 'schedule/manage')
      // this.$store.dispatch('setOpenedSub', ['schedule'])
      // sessionStorage.setItem('openedSub', '["schedule"]')
    },
    //切换视图
    viewChange(type, date, title) {
      this.type = type;
      switch (type) {
        case 'agendaWeek':
          this.showWeek = true
          this.showDay = false
          this.showMonth = false
          this.dataConf.date_type = 'week'
          this.dataConf.date = date
          this.chooseWeek = date
          this.weekTitle = title
          if (JSON.parse(localStorage.userInfo).id === this.dataConf.id) {
            this.events = this.eventWeek
          }
          break
        case 'agendaDay':
          this.showDay = true
          this.showWeek = false
          this.showMonth = false
          this.dataConf.date_type = 'day'
          this.dataConf.date = date
          this.chooseDay = date

          if (JSON.parse(localStorage.userInfo).id === this.dataConf.id) {
            this.events = this.eventWeek
          }
          break
        case 'month':
          this.showMonth = true
          this.showDay = false
          this.showWeek = false
          this.dataConf.date_type = 'month'
          this.dataConf.date = date
          this.chooseMonth = date
          if (JSON.parse(localStorage.userInfo).id === this.dataConf.id) {
            this.events = this.eventMonth
          }
          break
      }

      if (this.dataConf.id === JSON.parse(localStorage.userInfo).id) {
        this.initMyData();
      } else {
        this.getSchedule();
      }


    },
    initDate() {
      this.dataConf.date = new Date().getFullYear().toString() + '/' + ((new Date().getMonth()) + 1).toString() + '/' + new Date().getDate().toString()
    },
    getNewSchedule() {
      // this.isLoading = true;
      return this.$http.post(ScheduleAll.allSchedule, this.qs.stringify(this.dataConf), {
        headers: {
          'Authorization': 'Bearer ' + this.$cookie.get('token')
        }
      })
    },
    getAllUser(isSet) {
      let params = {
        orderBy: "englishName",
        asc: "asc"
      }
      this.$http.post(ScheduleAll.allUsers, this.qs.stringify(params), {
        headers: {
          'Authorization': 'Bearer ' + this.$cookie.get('token')
        }
      }).then(res => {
        const _data = res.data
        if (_data.retCode === 0) {
          this.allUser = _data.retData.data

          this.userInfo = this.allUser.filter((item) => item.id === JSON.parse(localStorage.userInfo).id)[0]
          if (isSet) {
            // this.idOpts = this.allUser
          }
        }
      })
    },
    change(item) {
      let userInfo = item
      userInfo.userName = userInfo.name
      this.userInfo = userInfo
    },
    //改变时间
    changeTime(type) {
      if (type == 'month') {
        this.dataConf.type = type;
        this.dataConf.date = dateToYMD(this.chooseMonth)
      } else if (type == 'week') {
        this.dataConf.type = type;
        this.dataConf.date = dateToYMD(this.chooseWeek)

      } else if (type == 'day') {
        this.dataConf.type = type;
        this.dataConf.date = dateToYMD(this.chooseDay)
      }

    },

    changeId(item) {
      this.dataConf.id = item.id
      this.userId = item.id
      this.userInfo = item
      this.showUserName = item.englishName
      if (JSON.parse(localStorage.userInfo).id === this.dataConf.id) {
        this.showAllBtn = true;
        this.initMyData();
      } else {
        this.getSchedule()
        this.showAllBtn = false;
      }
    },
    addPersonal(data) {
      // data.startTime = data.startTime.format('YYYY-MM-DD HH:mm')
      // data.startTime = data.startTime
      // data.endTime = data.endTime.format('YYYY-MM-DD HH:mm')
      // data.endTime = data.endTime
      this.$http.post(ScheduleAll.personal, this.qs.stringify(data), {
        headers: {
          'Authorization': 'Bearer ' + this.$cookie.get('token')
        }
      }).then(res => {
        let _data = res.data
        if (_data.retCode === 0) {
          this.isToast = true
          this.toastState = 'success'
          this.toastMsg = '添加成功'
        } else {
          this.isToast = true
          this.toastState = null
          this.toastMsg = _data.retMsg
        }
        setTimeout(() => {
          this.isToast = false
          this.toastState = null
          this.toastMsg = null
        }, 1500)
      })
    },
    //考勤
    getWorkTime() {
      let year, month, end, mon, start
      if (this.type == 'month') {
        year = this.chooseMonth.slice(0, 4);
        mon = this.chooseMonth.slice(5, 7);
        month = this.chooseMonth.slice(5, 7);
        let new_year = year; //取当前的年份
        let new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定） 为什么++而+1不可以
        if (month > 12) {
          new_month -= 12; //月份减
          new_year++; //年份增
        }
        let new_date = new Date(new_year, new_month, 1); //取当年当月中的第一天
        end = year + '-' + mon + '-' + new Date(new_date.getTime() - 1000 * 60 * 60 * 24).getDate();
        start = year + '-' + mon + '-' + '01'
        //获取当月最后一天日期
      } else if (this.type == 'agendaWeek') {
        let now = new Date(this.chooseWeek);
        let startWeek = new Date(this.chooseWeek);
        let endWeek = new Date(this.chooseWeek);
        let n = now.getDay(this.chooseWeek);
        startWeek.setDate(now.getDate() - n + 1);
        endWeek.setDate(now.getDate() - n + 7);
        start = dateToYMD(startWeek)
        end = dateToYMD(endWeek)
      } else if (this.type == 'agendaDay') {
        start = dateToYMD(this.chooseDay)
        end = dateToYMD(this.chooseDay)

      }

      this.attendanceParams = {
        start_date: start,
        end_date: end,
        userId: this.userId,
        page: 1,
        pageSize: 999,
      }
      return this.$http.post(ScheduleAll.attendance, this.qs.stringify(this.attendanceParams), {
        headers: {
          'Authorization': 'Bearer ' + this.$cookie.get('token')
        }
      })
    },
    //看别人的 没有打卡时间
    getSchedule() {
      this.$http.post(ScheduleAll.allSchedule, this.qs.stringify(this.dataConf), {
          headers: {
            'Authorization': 'Bearer ' + this.$cookie.get('token')
          }
        })
        .then((res) => {
          let _data = res.data
          this.isLoading = false
          if (_data.retCode === 0) {
            this.events = _data.retData.data.map((item) => {
              if (item.dataType === 'outing') {
                //外出  异地出差有areaList  本市外出开会没有 得用roomDetail  但是后台没有返
                item.areaList = item.areaList[0] === item.areaList[1] ? item.areaList.slice(1).join('') : item.areaList.join('')
              }
              let firstName = item.name
              if (this.type == 'month') {
                item.name = this.showTime(item)
              }
              console.log(item,'item------')
              return {
                allUserId:item.allUserId,
                auditorId:item.auditorId,
                creatorId:item.creatorId,
                firstName: firstName,
                title: item.name,
                start: item.startTime,
                end: item.endTime,
                agenda: item.agenda,
                room: item.room,
                roomName: item.roomName || item.areaList,
                scheduleId: item.id,
                creator: [item.createUser],
                status: item.timeStatusString || item.stateName,
                /* 新加的内容 */
                dataType: item.dataType,
                outingTypeName: item.outingTypeName,
                operationArr: item.operationArr,
                customerName: item.customerName,
                projectName: item.projectName,
                backgroundColor: item.dataType == 'meeting' ? 'rgba(237, 4, 35, 0.5)' : item.dataType == 'outing' ? 'rgba(52, 209, 191, 0.5)' : 'rgba(247, 181, 0, 0.5)',
                color: item.dataType == 'meeting' ? 'rgba(237, 4, 35, 0.5)' : item.dataType == 'outing' ? 'rgba(52, 209, 191, 0.5)' : 'rgba(247, 181, 0, 0.5)',
                textColor: 'black',
                recorderUserItems: item.recorderUserItems,
                allUserItems: item.allUserItems || item.operationArr,
                id: item.id || item.outingId
              }
            })
            if (this.type != 'month') {
              this.initWeekDay()
            }
          } else {
            this.isToast = true
            this.toastMsg = _data.retMsg
            this.toastState = null
          }
          setTimeout(() => {
            this.isToast = false
          }, 1500)
        })
    },
    showTime(item) {
      //开始时间结束时间格式化
      let startmon = item.startTime.slice(5, 6) == 0 ? item.startTime.slice(6, 7) : item.startTime.slice(5, 7);
      let startDay = item.startTime.slice(8, 9) == 0 ? item.startTime.slice(9, 10) : item.startTime.slice(8, 10);
      let endmon = item.endTime.slice(5, 6) == 0 ? item.endTime.slice(6, 7) : item.endTime.slice(5, 7);
      let endDay = item.endTime.slice(8, 9) == 0 ? item.endTime.slice(9, 10) : item.endTime.slice(8, 10);
      let startHour = item.startTime.slice(10);
      let endHour = item.endTime.slice(10);

      if (item.startTime.slice(0, 10) != item.endTime.slice(0, 10)) {

        return startHour + '-' + endmon + '/' + endDay + endHour + item.name
        // return startmon + '/' + startDay + startHour + '-' + endmon + '/' + endDay + endHour + item.name
      } else {
        return startHour + item.name
      }
    },
    getData(x, y) {
      console.log(x,'x----',y,'y-------')
      const event = x.data.retData.data;
      const workTime = y.data.retData;
      let start = dateToYMD(new Date()) + ' 09:00'
      let end = dateToYMD(new Date()) + ' 10:00'
      //判断事件里有没有待办事项
      let hasWait = this.events.some(function (item, index, array) {
        return item.dataType == '待办事项'
      })
      //今天并且是本人才会有待办事项并且有待办事项
      if (this.dataConf.id === JSON.parse(localStorage.userInfo).id && this.number != 0 && this.number != null&&hasWait==false) {
        event.push({
          name: `待办事项（${this.number==null?0:this.number}）`,
          startTime: start,
          endTime: end,
          dataType: '待办事项',
          backgroundColor: 'rgba(45, 142, 248, 0.5)',
          color: 'rgba(45, 142, 248, 0.5)',
          textColor: 'black',
          todoList: [],
          id: 0,
        })
      }
      //月视图  考勤
      event.forEach(element => {
        workTime.data.forEach(item => {
          if (item.startDateTime != null && item.startDateTime.slice(0, 10) == element.startTime.slice(0, 10)) {
            //上班时间下班时间
            element.workStartTime = item.startTime
            element.workEndTime = item.endTime
          }
        })
        workTime.unFinishData.forEach(i => {
          if (i.atten_time_f != null && element.startTime.slice(0, 10) == i.atten_time_f.slice(0, 10)) {
            element.workStartTime = i.atten_time_f.slice(11)
            // element.workEndTime = i.endTime
          }
        })
      })
      //月视图
      this.eventMonth = event.map((item) => {

        if (item.dataType === 'outing') {
          if (Array.isArray(item.areaList) && item.areaList != '') {
            item.areaList = item.areaList[0] === item.areaList[1] ? item.areaList.slice(1).join('') : item.areaList.join('')

          } else {
            item.roomName = item.roomDetail
          }
        }
        let firstName = item.name
        if (item.dataType == '待办事项') {
          return {
            
            title: item.name,
            start: item.startTime,
            dataType: item.dataType,
            backgroundColor: item.dataType == 'meeting' ? 'rgba(237, 4, 35, 0.5)' : item.dataType == 'outing' ? 'rgba(52, 209, 191, 0.5)' : item.dataType == 'vacation' ? 'rgba(247, 181, 0, 0.5)' : item.color,
            color: item.dataType == 'meeting' ? 'rgba(237, 4, 35, 0.5)' : item.dataType == 'outing' ? 'rgba(52, 209, 191, 0.5)' : item.dataType == 'vacation' ? 'rgba(247, 181, 0, 0.5)' : item.color,
            textColor: 'black',
            end: item.endTime,
            firstName: firstName,
            todoList: item.todoList,
            id: item.id,
            // className: item.dataType == 'meeting'?'meeting-class': item.dataType == 'outing' ?'outing-class':item.dataType=='vacation'?'vacation-class':'normcal-class'
          }
        } else {
          // item.name = this.showTime(item)
          if (this.type == 'month') {
            item.name = this.showTime(item)
          }
          return {
            allUserId:item.allUserId,
            firstName: firstName,
            title: item.name,
            start: item.startTime,
            end: item.endTime,
            agenda: item.agenda,
            room: item.room,
            roomName: item.roomName || item.areaList,
            scheduleId: item.id,
            creator: [item.createUser],
            status: item.timeStatusString || item.stateName,
            /* 新加的内容 */
            dataType: item.dataType,
            outingTypeName: item.outingTypeName,
            operationArr: item.operationArr,
            customerName: item.customerName,
            projectName: item.projectName,
            backgroundColor: item.dataType == 'meeting' ? 'rgba(237, 4, 35, 0.5)' : item.dataType == 'outing' ? 'rgba(52, 209, 191, 0.5)' : item.dataType == 'vacation' ? 'rgba(247, 181, 0, 0.5)' : item.color,
            color: item.dataType == 'meeting' ? 'rgba(237, 4, 35, 0.5)' : item.dataType == 'outing' ? 'rgba(52, 209, 191, 0.5)' : item.dataType == 'vacation' ? 'rgba(247, 181, 0, 0.5)' : item.color,
            textColor: 'black',
            recorderUserItems: item.recorderUserItems,
            allUserItems: item.allUserItems || item.operationArr,
            // allUserItems: item.recorderUserItems || item.operationArr,
            // stateName:item.stateName,
            // operationArr:,
            id: item.id || item.outingId,
            // workStartTime: item.workStartTime,
            // workEndTime: item.workEndTime,
            dayCountE2: item.dataType == 'vacation' ? item.dayCountE2 : ''
            // url:`/new/schedule/detail/${item.id}`
          }
        }

      });
      //默认月视图  events的数据是month，没有每日的上下班打卡
      this.events = this.eventMonth;
      this.eventWeek = this.events;
      // for (let i of workTime.data) {
      //   let punch = []
      //   if (i.startDateTime != null) {
      //     punch.push({
      //       start: dateToYMD(i.startDateTime.slice(0, 11)) + ' 08:35',
      //       title: `上班：${i.startTime}`,
      //       textColor: "black",
      //       color: 'white',
      //       dataType: '考勤'
      //     })
      //   }
      //   if (i.endDateTime != null) {
      //     punch.push(
      //       {
      //         start: dateToYMD(i.endDateTime.slice(0, 11)) + ' 20:35',
      //         title: `下班：${i.endTime}`,
      //         textColor: "black",
      //         color: 'white',
      //         dataType: '考勤'
      //       }
      //     )
      //   }
      //   //周和日视图  添加了每日的上下班打卡
      //   this.eventWeek = [...punch, ...this.eventWeek]


      // }
      // for (let i of workTime.unFinishData) {
      //   let punch = []
      //   if (i.atten_time_f != null) {

      //     punch.push({
      //       start: dateToYMD(i.atten_time_f.slice(0, 11)) + ' 08:35',
      //       // end:`${i.startDateTime.slice(0,11)}9:30`,
      //       title: `上班：${i.atten_time_f.slice(11)}`,
      //       textColor: "black",
      //       color: 'white',
      //       dataType: '考勤'
      //     })
      //     //周和日视图  添加了每日的上下班打卡
      //   }
      //   if (i.endDateTime != null) {
      //     punch.push({
      //       start: i.endDateTime.slice(0, 11) != null ? dateToYMD(i.endDateTime.slice(0, 11)) + ' 20:35' : '',
      //       title: `下班：${i.endTime}`,
      //       textColor: "black",
      //       color: 'white',
      //       dataType: '考勤'
      //     })
      //   }
      //   this.eventWeek = [...punch, ...this.eventWeek]

      // }

      if (this.type != 'month') {
        this.events = this.eventWeek;
        this.initWeekDay();
      }
      this.isLoading = false;
    },
    //如果跨天 去掉19-10之间的颜色渲染
    initWeekDay() {
      this.events.forEach(item => {
        if (item.dataType != '考勤') {
          let star = item.start.slice(0, 10);
          let end = item.end.slice(0, 10);
          if (star != end) {
            this.getDateStr(star, end, 0);
            this.someDay = this.someDay.replace(/,/g, '')
            //两位数
            // if(this.someDay.length<100){
            let num = Math.ceil(this.someDay.length / 10) + 1;
            for (let i = 1; i < num; i++) {
              let newEvent = {
                allUserId:item.allUserId,
                auditorId:item.auditorId,
                creatorId:item.creatorId,
                firstName: item.firstName,
                title: item.firstName,
                start: this.someDay.slice((i - 1) * 10, i * 10) + ' 10:00',
                end: this.someDay.slice((i - 1) * 10, i * 10) + ' 19:00',
                agenda: item.agenda,
                room: item.room,
                roomName: item.roomName,
                scheduleId: item.scheduleId,
                creator: item.creator,
                status: item.status,
                /* 新加的内容 */
                dataType: item.dataType,
                outingTypeName: item.outingTypeName,
                operationArr: item.operationArr,
                customerName: item.customerName,
                projectName: item.projectName,
                backgroundColor: item.backgroundColor,
                color: item.color,
                textColor: item.textColor,
                recorderUserItems: item.recorderUserItems,
                allUserItems: item.allUserItems,
                // stateName:item.stateName,
                // operationArr:,
                id: item.id,
                // workStartTime: item.workStartTime,
                workEndTime: item.workEndTime,
                dayCountE2: item.dayCountE2
              }
              if (i > 1) {
                if (i == (num - 1)) {
                  newEvent.end = this.someDay.slice((i - 1) * 10, i * 10) + item.end.slice(10)
                } else {

                }
                this.events.push(newEvent)
              }
            }
            item.start = item.start;
            item.end = star + ' 19:00';
            item.title = item.start.slice(11) + item.firstName
          }
        }
      })
      if (this.type == 'agendaDay') {

        for (let i of this.events) {
          if (i.dataType != '考勤') {
            i.className = "textitle"
          }

        }
      }
      this.isLoading = false;
    },
    // startDate: 计划开始时间； endDate：计划结束时间；dayLength：每隔几天，0-代表每天，1-代表日期间隔一天
    getDateStr(startDate, endDate, dayLength) {
      let str = startDate;
      for (let i = 0;; i++) {
        let getDate = this.getTargetDate(startDate, dayLength);
        startDate = getDate;

        if (getDate <= endDate) {

          str += ',' + getDate;
        } else {
          break;
        }
      }
      this.someDay = str;
    },

    // startDate: 开始时间；dayLength：每隔几天，0-代表获取每天，1-代表日期间隔一天
    getTargetDate(date, dayLength) {
      dayLength = dayLength + 1;
      let tempDate = new Date(date);
      tempDate.setDate(tempDate.getDate() + dayLength);
      let year = tempDate.getFullYear();
      let month = tempDate.getMonth() + 1 < 10 ? "0" + (tempDate.getMonth() + 1) : tempDate.getMonth() + 1;
      let day = tempDate.getDate() < 10 ? "0" + tempDate.getDate() : tempDate.getDate();
      return year + "-" + month + "-" + day;
    },

    async initMyData() {
      this.events = [];
      this.eventWeek = [];
      this.eventMonth = [];
      await Promise.all([
        (async () => {
          this.scheduleList = await this.getNewSchedule();
        })(),
        (async () => {
          this.workTimeList = await this.getWorkTime();
        })(),
      ])
      this.getData(this.scheduleList, this.workTimeList);
    }
  },
  async created() {
    // this.isLoading = true;
    this.init();
  },
  mounted() {

  },
  computed: {
    userName() {
      return JSON.parse(localStorage.getItem("userInfo")).userName
    }
  }
}
